import script from "./SolutionPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SolutionPage.vue?vue&type=script&setup=true&lang=js"

import "./SolutionPage.vue?vue&type=style&index=0&id=2ad13f04&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ad13f04"]])

export default __exports__